export const toolbar = {
  root: {
    background: "{content.background}",
    borderColor: "{content.border.color}",
    borderRadius: "0",
    color: "{content.color}",
    gap: "{gap.8}",
    padding: "{padding.16}",
  },
  extend: {
    ui: {
      root: {
        borderWidth: "0 0 {border.width.1}",
      },
    },
  },
  css: ({ dt }: any): string => `
    .p-toolbar {
      border-width: ${dt("toolbar.ui.border.width")};
    }
  `,
};
